import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { AppointmentCTA } from "@/components/AppointmentCTA";
import { Icon } from "@/utils/icons";
import { SITE } from "@/config/site";
import { HEALTH_TIPS } from "@/data/healthTips";

export default function HealthTips() {
  return (
    <>
      <Seo
        title={`Health Tips — ${SITE.name}`}
        siteName={SITE.name}
        description={`Practical health and wellness tips for families in Kasdol, Chhattisgarh from ${SITE.name}.`}
      />
      <PageHeader
        title="Health Tips"
        description="Simple, practical guidance for staying healthy — general information only, not a substitute for a medical consultation."
        crumbs={[{ label: "Health Tips" }]}
      />
      <section className="py-16 sm:py-20" data-testid="health-tips-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
            {HEALTH_TIPS.map((t) => (
              <article
                key={t.title}
                className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                data-testid={`health-tip-${t.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-100 text-emerald-600">
                  <Icon name={t.icon} className="h-5 w-5" aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-lg font-semibold text-navy-900">{t.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{t.excerpt}</p>
              </article>
            ))}
          </div>
          <p className="mt-10 text-center text-xs text-slate-500">
            These tips are general wellness information. For advice about your own health, please consult a doctor.
          </p>
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
